import React, { useMemo, useState } from "react";
import { apiPost } from "../api";
import type { Locale } from "../i18n";
import { t } from "../i18n";
import { BtnSpinner } from "../components/BtnSpinner";

export function ForgotPasswordView(props: { locale: Locale }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const canSubmit = useMemo(() => email.trim().length > 3, [email]);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await apiPost<{ ok: true }>("/v1/password-reset/request", { email: email.trim().toLowerCase() });
      if (!res.ok) {
        setError(res.error);
        return;
      }
      setSent(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="authShell">
      <div className="authBg" />
      <div className="authWrap">
        <a className="authBrand" href="/" aria-label="KVEJA home">
          <img className="authLogo" src="/brand/kveja_logo.png" alt="KVEJA" />
        </a>

        <div className="authCard">
          <div className="authHeader">
            <h1 className="authTitle">{t(props.locale, "forgotPassword.title")}</h1>
            <p className="authSubtitle">{t(props.locale, "forgotPassword.subtitle")}</p>
          </div>

          {sent ? (
            <div className="authForm">
              <p className="authSuccess">{t(props.locale, "forgotPassword.success")}</p>
              <div className="authRow authRowBottom">
                <a className="btn authBtnSecondary" href="/login">{t(props.locale, "forgotPassword.backToLogin")}</a>
              </div>
            </div>
          ) : (
            <form className="authForm" onSubmit={onSubmit}>
              <div className="authField">
                <div className="authLabel">{t(props.locale, "forgotPassword.email")}</div>
                <input
                  className="authInput"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  autoComplete="username"
                  inputMode="email"
                  placeholder="you@domain.com"
                  required
                />
              </div>

              {error ? <div className="authError">{error}</div> : null}

              <div className="authRow">
                <div />
                <button className="btn primary authBtn" disabled={!canSubmit || busy} type="submit">
                  <BtnSpinner loading={busy}>{busy ? t(props.locale, "forgotPassword.submitting") : t(props.locale, "forgotPassword.submit")}</BtnSpinner>
                </button>
              </div>

              <div className="authRow authRowBottom">
                <a className="btn authBtnSecondary" href="/login">{t(props.locale, "forgotPassword.backToLogin")}</a>
              </div>
            </form>
          )}
        </div>

        <div className="authFooter">
          <span className="small">KVEJA</span>
          <span className="authDot" aria-hidden="true">·</span>
          <a className="small" href="/">Back to landing</a>
        </div>
      </div>
    </div>
  );
}
